<div class="loader">
  <div class="line line1 theme-loader__common"></div>
  <div class="line line2 theme-loader__common"></div>
  <div class="line line3 theme-loader__common"></div>
</div>
